// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Button from "@store/MobiusOverrides/Button/Button";
import { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Props";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    subtitle = "subtitle",
    videoId = "videoId",
    destination = "destination",
    overrideTitle = "overrideTitle",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.subtitle]: string;
        [fields.videoId]: string;
        [fields.destination]: LinkFieldValue;
        [fields.overrideTitle]: string;
    };
}
export interface NewsVideoStyles {
    gridContainer?: GridContainerProps;
    videoGridItem?: GridItemProps;
    textGridItem?: GridItemProps;
    video?: InjectableCss;
    button?: ButtonPresentationProps;
}

export const newsVideoStyles: NewsVideoStyles = {
    videoGridItem: { width: [12, 12, 12, 7, 7] },
    textGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            flex-direction: column;
        `,
    },
    video: {
        css: css`
            width: 100%;
            padding-bottom: 56.25%;
            position: relative;
            > iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        `,
    },
};

type Props = OwnProps;

const styles = newsVideoStyles;

const NewsVideo: FC<Props> = ({ fields }) => {
    const { title, url } = useGetLink(fields.destination);
    const label = fields.overrideTitle || title;

    const clickHandler = () => {
        window.open(url, "_self");
    };

    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.videoGridItem}>
                <StyledWrapper {...styles.video}>
                    <iframe
                        src={`https://www.youtube.com/embed/${fields.videoId}`}
                        title={fields.title || ""}
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                        allowFullScreen
                    ></iframe>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.textGridItem}>
                {fields.title && <Typography variant="h2">{fields.title}</Typography>}
                {fields.subtitle && <Typography variant="p">{fields.subtitle}</Typography>}
                {label !== "" && url !== "" && (
                    <Button {...styles.button} onClick={clickHandler}>
                        {label}
                    </Button>
                )}
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: NewsVideo,
    definition: {
        displayName: "News Video",
        icon: "image",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.subtitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.videoId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.destination,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.overrideTitle,
                displayName: "Override Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
